import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom';


import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import Header from './Components/Header'
import Home from './Components/Home';
import WebDesignAndDevelopment from './Components/WebDesignAndDevelopment'
import AboutUs from './Components/AboutUs';
import MobileAppDevelopment from './Components/MobileAppDevelopment';
import DigitalMarketing from './Components/DigitalMarketing';
import PowerBIServices from './Components/PowerBIServices';
import ServiceNowDevelopment from './Components/ServiceNowDevelopment';
import InfrastructureDevelopment from './Components/InfrastructureDevelopment';
import ApplicationDevelopment from './Components/ApplicationDevelopment';
import ProcessOutsourcing from './Components/ProcessOutsourcing';
import CloudMigration from './Components/CloudMigration';
import DataIntegration from './Components/DataIntegration';
import Mainframes from './Components/Mainframes';
import ProductEngineering from './Components/ProductEngineering';
import CustomerExperienceAndCPQ from './Components/CustomerExperienceAndCPQ';
import SupplyChainOptimization from './Components/SupplyChainOptimization';
import BigDataandAnalytics from './Components/BigDataandAnalytics';
import MobilityandUX from './Components/MobilityandUX';
import AIandML from './Components/AIandML';
import RoboticProcessAutomation from './Components/RoboticProcessAutomation';
import InternetofThings from './Components/InternetofThings';
import HumanCapitalManagement from './Components/HumanCapitalManagement';
import SAPEnterpriseSystems from './Components/SAPEnterpriseSystems';
import SalesforcePlatforms from './Components/SalesforcePlatforms';
import OracleEnterpriseSolutions from './Components/OracleEnterpriseSolutions';
import MicrosoftCloudSolutions from './Components/MicrosoftCloudSolutions';
import AWSCloudSolutions from './Components/AWSCloudSolutions';
import NetSuiteEnterpriseSolutions from './Components/NetSuiteEnterpriseSolutions';
import ManufacturingSolutions from './Components/ManufacturingSolutions';
import HealthcareAndBiotechSolutions from './Components/HealthcareAndBiotechSolutions';
import AutomotiveSolutions from './Components/AutomotiveSolutions';
import HighTechSolutions from './Components/HighTechSolutions';
import Aerospace from './Components/Aerospace';
import RetailAndDistribution from './Components/RetailAndDistribution';
import ConsumerGoods from './Components/ConsumerGoods';
import Construction from './Components/Construction';
import MediaAndEntertainment from './Components/MediaAndEntertainment';
import CareersHub from './Components/CareersHub';
import Footer from './Components/Footer';
import ContactUs from './Components/ContactUs';

const App = () => {
  return (
    <div>
      <BrowserRouter>
      <Header />

        <Routes>

          <Route path='/' element={<Home />} />
          <Route path='/about-us' element={<AboutUs/>} />
          <Route path='/web-design-and-development' element={<WebDesignAndDevelopment />} />
          <Route path='/mobile-app-development' element={<MobileAppDevelopment />} />    
          <Route path='/digital-marketing' element={<DigitalMarketing/>} />
          <Route path='/power-bi-services' element={<PowerBIServices />} />
          <Route path='/servicenow-development' element={<ServiceNowDevelopment />} />
          <Route path='/infrastructure-development' element={<InfrastructureDevelopment />} /> 
          <Route path='/application-development' element={<ApplicationDevelopment/>} /> 
          <Route path='/process-outsourcing' element={<ProcessOutsourcing />} /> 
          <Route path='/cloud-migration' element={<CloudMigration />} /> 
          <Route path='/data-integration' element={<DataIntegration />} />
          <Route path='/mainframes-computing' element={<Mainframes />} />
          <Route path='/product-engineering' element={<ProductEngineering />} />
          <Route path='/customer-experience-and-cpq' element={<CustomerExperienceAndCPQ />} />
          <Route path='/supply-chain-optimization' element={<SupplyChainOptimization />} />
          <Route path='/big-data-and-analytics' element={<BigDataandAnalytics />} />
          <Route path='/mobility-and-ux' element={<MobilityandUX />} />
          <Route path='/ai-and-ml' element={<AIandML />} />
          <Route path='/robotic-process-automation' element={<RoboticProcessAutomation />}  />
          <Route path='/internet-of-things' element={<InternetofThings />}  />
          <Route path='/human-capital-management' element={<HumanCapitalManagement />}  />
          <Route path='/sap-enterprise-systems' element={<SAPEnterpriseSystems />} />
          <Route path='/salesforce-platforms' element={<SalesforcePlatforms />}  />
          <Route path='/oracle-cloud-and-database-solutions' element={<OracleEnterpriseSolutions />} />
          <Route path='/microsoft-cloud-solutions' element={<MicrosoftCloudSolutions />} />
          <Route path='/aws-cloud-solutions' element={<AWSCloudSolutions />}  />
          <Route path='/netsuite-enterprise-solutions' element={<NetSuiteEnterpriseSolutions />}  />
          <Route path='/manufacturing-solutions' element={<ManufacturingSolutions />} />
          <Route path='/healthcare-and-biotech-solutions' element={<HealthcareAndBiotechSolutions />} />
          <Route path='/automotive-solutions' element={<AutomotiveSolutions />} />
          <Route path='/high-tech-solutions' element={<HighTechSolutions />} />
          <Route path='/aerospace' element={<Aerospace />} />
          <Route path='/retail-and-distribution' element={<RetailAndDistribution />}  />
          <Route path='/consumer-goods' element={<ConsumerGoods />} />
          <Route path='/construction' element={<Construction />} />
          <Route path='/media-and-entertainment' element={<MediaAndEntertainment />} />
          <Route path='/careers-hub' element={<CareersHub />} />
          <Route path='/contact-us' element={<ContactUs />} />

          
        </Routes>   
        <Footer />   
      
      </BrowserRouter>
      
    </div>
  )
}

export default App
